const base = import.meta.env.BASE_URL.replace(/\/$/, "");

type DnaLogoProps = {
  className?: string;
  width: number;
  height: number;
  loading?: "lazy" | "eager";
  fetchPriority?: "high" | "low" | "auto";
};

/** Tyler's 2026 DNA wordmark: WebP with a PNG fallback. */
export function DnaLogo({ className, width, height, loading, fetchPriority }: DnaLogoProps) {
  return (
    <picture>
      <source srcSet={`${base}/dna-logo-2026.webp`} type="image/webp" />
      <img
        src={`${base}/dna-logo-2026.png`}
        alt="Don Norman Associates"
        width={width}
        height={height}
        className={className}
        decoding="async"
        loading={loading}
        {...(fetchPriority ? { fetchPriority } : {})}
      />
    </picture>
  );
}
